import React, { Component } from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import auth from '../../functions/auth';
import { Link, withRouter } from 'react-router-dom';
// import axios from "axios";
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import '../../pages/datepicker.css'

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: '',
      active: '',
      timeValue: this.props?.location?.state?.timeValue || (() => {
        let date = new Date()
        let days = date.getDate()
        if (parseInt(days) < 10) {
          days = `0${days}`
        }
        let month = parseInt(date.getMonth()) + 1
        if (parseInt(month) < 10) {
          month = `0${month}`
        }
        let year = date.getFullYear()
        let saveDate = `${year}-${month}-${days}`
        return saveDate
      })(),
      timeShow: this.props?.location?.state?.timeShow || new Date()
    };
    this.onChageDate = this.onChageDate.bind(this)
  }
  onChageDate = (date) => {
    date = new Date(date)
    let days = date.getDate()
    if (parseInt(days) < 10) {
      days = `0${days}`
    }
    let month = parseInt(date.getMonth()) + 1
    if (parseInt(month) < 10) {
      month = `0${month}`
    }
    let year = date.getFullYear()
    let saveDate = `${year}-${month}-${days}`
    this.setState({
      ...this.state,
      timeValue: saveDate,
      timeShow: date
    }, () => {
      console.log(this.props.location)
      console.log(this.state)
      let pathHandle = this.state.active
      let isReload = true
      if (pathHandle == '/ValidateCheckWeight') {
        pathHandle = '/CheckWeightTable'
        isReload = false
      }
      if (pathHandle == '/request') {
        pathHandle = '/requestTable'
        isReload = false
      }
      if (pathHandle == '/RequestEdit') {
        pathHandle = '/RequestEditTable'
        isReload = false
      }

      console.log(pathHandle, isReload)
      if (isReload) {
        this.props.history.push({
          pathname: `${pathHandle}`,
          state: {
            timeValue: saveDate,
            timeShow: date
          }
        })
        window.location.reload()
      } else {
        this.props.history.push({
          pathname: pathHandle,
          state: {
            timeValue: saveDate,
            timeShow: date
          }
        })
      }
    })
  }

  componentWillMount() {
    console.log('new mount')
    console.log(this.props.location)
    this.setState({
      ...this.state,
      userRole: localStorage.getItem('username') || '',
      active: this.props.location.pathname,
    });
  }
  Logout = () => {
    auth.logout(() => {
      this.props.history.push('/');
    });
  };
  render() {
    return (
      <div style={{ zIndex: '99' }}>
        <Navbar>
          <Nav />
          <Navbar.Collapse className="justify-content-start">
            <Navbar>
              {/* {console.log(this.state)} */}
              <DatePicker
                className='form-control'
                selected={this.state.timeShow || new Date()}
                onChange={this.onChageDate}
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="MMMM d, yyyy"
              />
            </Navbar>
          </Navbar.Collapse>
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text>Signed in as: {this.state.userRole}</Navbar.Text>
          </Navbar.Collapse>
        </Navbar>

        <Navbar>

          <Nav>
            <Link
              to={{
                pathname: "requestTable",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}>
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/request' ||
                  this.state.active === '/requestTable' ||
                  this.state.active === '/requestDate' ? 'active' : ''}
              >
                แจ้งขอตรวจสอบ
              </Button>
            </Link>
            <Link
              to={{
                pathname: "RequestEditTable",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}>
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/RequestEditCalendar' ||
                  this.state.active == '/RequestEdit' ||
                  this.state.active == '/RequestEditTable' ? 'active' : ''}
              >
                แก้ไขแจ้งขอตรวจสอบ
              </Button>
            </Link>

            
            {/* <Link to="RequestMemCalendar">
              <Button
              size="sm"
                variant="outline-primary"
                className={this.state.active === '/RequestMemCalendar' ? 'active' : ''}
              >
                บันทึกการรับแจ้ง
              </Button>
            </Link> */}
            {/* <Link to="JobCalendar">
              <Button
              size="sm"
                variant="outline-primary"
                className={this.state.active === '/JobCalendar' || this.state.active === '/AddJob' ? 'active' : ''}
              >
                เสนอจ่ายงาน
              </Button>
            </Link> */}
            <Link
              to={{
                pathname: "RequestDaily",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}

            >
              <Button
                size="sm"
                variant="outline-primary"
                className={(() => {
                  if (this.state.active === '/RequestCalendar' || this.state.active === '/RequestDaily') {
                    return 'active'
                  } else {
                    return ''
                  }
                })()}
              >
                บันทึกการรับแจ้ง
                {/* สรุปแจ้งขอตรวจสอบรายวัน */}
              </Button>
            </Link>
            <Link to="requested">
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/requested' ? 'active' : ''}
              >
                ประวัติใบอนุญาต
              </Button>
            </Link>



            <Link
              to={{
                pathname: "CheckWeightTable",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}
            >
              <Button
                size="sm"
                variant="outline-primary"
                className={
                  this.state.active === '/CheckWeight' ||
                    this.state.active === '/ValidateCheckWeight' ||
                    this.state.active === '/CheckWeightCalendar' ||
                    this.state.active === '/CheckWeightTable'
                    ? 'active'
                    : ''
                }
              >
                Checkweight
              </Button>
            </Link>
           

            <Link
              to={{
                pathname: "JobSummary",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}

            >
              <Button
                size="sm"
                variant="outline-primary"
                className={(() => {
                  if (this.state.active === '/JobSummary' || this.state.active === '/JobSummary') {
                    return 'active'
                  } else {
                    return ''
                  }
                })()}
              >
                ปิดงาน
                {/* สรุปแจ้งขอตรวจสอบรายวัน */}
              </Button>
            </Link>

            <Link
              to={{
                pathname: "FinancialWageCalendar",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}
            >
              <Button
                size="sm"
                variant="outline-primary"
                className={
                  this.state.active === '/FinancialWageCalendar' ||
                    this.state.active === '/FinancialWageTable'
                    ? 'active'
                    : ''
                }
              >
                คำนวนค่าแรง
              </Button>
            </Link>

            <Link to="ValidCalendar">
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/ValidCalendar' ||
                  this.state.active === '/ValidCalendar' ||
                  this.state.active === '/ValidPageTable'
                  ? 'active' : ''}
              >
                ส่วนวิเคราะห์
              </Button>
            </Link>

            <Link
              to={{
                pathname: "CertificateTable",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}
            >
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/Certificate' ||
                  this.state.active === '/CertificateCalendar' ? 'active' : '' ||
                    this.state.active === '/CertificateTable' ? 'active' : '' ||
                      this.state.active === '/CertiPage' ? 'active' : ''}
              >
                ใบรับรอง
              </Button>
            </Link>

            <Link
              to={{
                pathname: "SumCertificate",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}
            >
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/SumCertificate' ? 'active' : ''}
              >
                สรุปใบรับรอง
              </Button>
            </Link>
            <Link
              to={{
                pathname: "CertificateRequested",
                state: { timeValue: this.state.timeValue, timeShow: this.state.timeShow }
              }}
            >
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/CertificateRequested' ? 'active' : ''}
              >
                ประวัติใบรับรอง
              </Button>
            </Link>


            <Link to="HealthCert">
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/HealthCert' ? 'active' : ''}
              >
                HealthCert
              </Button>
            </Link>



            <Link to="Statistics">
              <Button
                size="sm"
                variant="outline-primary"
                className={this.state.active === '/Statistics' ? 'active' : ''}
              >
                สถิติ
              </Button>
            </Link>


          </Nav>

          <Navbar.Collapse className="justify-content-end">
            <Link to="adminsys">
              <Button variant="outline-primary">ระบบผู้ดูแล</Button>
            </Link>
            <Button variant="danger" onClick={this.Logout}>
              ออกจากระบบ
            </Button>
          </Navbar.Collapse>

        </Navbar>
      </div>
    );
  }
}

export default withRouter(NavBar);
